import { styled } from "@mui/material/styles";
import Autocomplete from "@mui/material/Autocomplete";

export const AutocompleteStyled = styled(Autocomplete)({
  flex: "1 1 200px",
});
